const designProjects = [
  {
    type: "Print Design",
    software: ["Adobe Illustrator", "Adobe Photoshop"],
    name: "Black Plaid",
    imgUrl: "black-plaid.png",
    description: "Deisgned a black plaid print for brand's new product development."
  },
  {
    type: "Logo Design",
    software: "Adobe Illustrator",
    name: 'The Creators',
    imgUrl: "creators.png",
    description: "Deisgned logo for private client. Incorporated paint brush, light bulb, and flame."
  },
  {
    type: "Logo Design",
    software: "Adobe Illustrator",
    name: "Baby K'tan",
    imgUrl: "babyktan1.png",
    description: "Refreshed brand logo to more modern look while keeping with brand font and style."
  },
  {
    type: "Logo Design",
    software: "Adobe Illustrator",
    name: "Glass Cocktail Bar",
    imgUrl: "glass.png",
    description: "Deisgned cocktail bar logo for private client."
  },
  {
    type: "Print Design",
    software: ["Adobe Illustrator", "Adobe Photoshop"],
    name: "Arrow",
    imgUrl: "arrow-print.png",
    description: "Deisgned a classic arrow print for brand's new product development."
  },
  {
    type: "Vector Design",
    software: ["Adobe Illustrator"],
    name: "Avatar",
    imgUrl: "tali-large.png",
    description: "Deisgned vector self-portrait for use as avatar."
  },
  {
    type: "Print Design",
    software: ["Adobe Illustrator", "Adobe Photoshop"],
    name: "Pink Plaid",
    imgUrl: "pink-plaid.png",
    description: "Deisgned a pink plaid print for brand's new product development."
  },
  {
    type: "Logo Design",
    software: "Adobe Illustrator",
    name: "WhoDat",
    imgUrl: "whodat-logo.png",
    description: "Deisgned logo for WhoDat.actor project."
  },
]

export default designProjects
